const urlName = '/usercenter/v2/t-b/account'

export default (API) => ({
	// 登录
	postAccountLogin(data) {
		return API({ url: `${urlName}/login`, method: 'post', data })
	},
	switchSaas(params) {
		return API({ url: `${urlName}/switchSaas`, method: 'post', params })
	},
	// 选择用户身份
	switchIdentity(params) {
		return API({ url: `${urlName}/switchIdentity`, method: 'post', params })
	},
	switchBranch(params) {
		return API({ url: `${urlName}/switchBranch`, method: 'post', params })
	},
	logout() {
		return API({ url: `${urlName}/logout`, method: 'post' })
	},
	// 获取授权码用于登录
	getPhoneAuthCode4Login(params) {
		return API({ url: `${urlName}/getPhoneAuthCode4Login`, method: 'post', params })
	},
	// 获取邮箱授权码,用于登录
	getMailAuthCode4Login(params) {
		return API({ url: `${urlName}/getMailAuthCode4Login`, method: 'post', params })
	},
	// 获取手机授权码用于修改密码
	getPhoneAuthCode4ChangePwd(params) {
		return API({ url: `${urlName}/getPhoneAuthCode4ChangePwd`, method: 'post', params })
	},
	// 获取邮箱授权码,用于修改密码
	getMailAuthCode4ChangePwd(params) {
		return API({ url: `${urlName}/getMailAuthCode4ChangePwd`, method: 'post', params })
	},
	// 手机验证码修改密码
	changePasswordByPhoneAuthCode(data) {
		return API({ url: `${urlName}/changePasswordByPhoneAuthCode`, method: 'post', data })
	},
	// 邮箱验证码修改密码
	changePasswordByMailAuthCode(data) {
		return API({
			url: `${urlName}/changePasswordByMailAuthCode`,
			method: 'post',
			data,
		})
	},
})
